/** @format */

import {
  SET_SKILL_TREE_CACHE,
  GET_SKILL_TREE_CACHE,
  CLEAR_SKILL_TREE_CACHE,
  SET_AI_CONFIGURATION,
} from "../action/skillTreeCache";

const initialState = {
  cache: {}, // Structure: { [cacheKey]: { level1And2Data: {...}, timestamp: number } }
  aiConfiguration: null, // Store AI models and other config
};

export default function SkillTreeCacheReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SKILL_TREE_CACHE:
      const { cacheKey, data } = action.payload;
      return {
        ...state,
        cache: {
          ...state.cache,
          [cacheKey]: {
            level1And2Data: data,
            timestamp: Date.now(),
          },
        },
      };

    case GET_SKILL_TREE_CACHE:
      // This action is mainly for getting cache, but reducer just returns state
      // The actual cache retrieval happens in selectors/components
      return state;

    case CLEAR_SKILL_TREE_CACHE:
      const { cacheKey: keyToClear } = action.payload;
      const newCache = { ...state.cache };
      delete newCache[keyToClear];
      return {
        ...state,
        cache: newCache,
      };

    case SET_AI_CONFIGURATION:
      return {
        ...state,
        aiConfiguration: action.payload,
      };

    default:
      return state;
  }
}

